// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Divider, Switch } from "@material-ui/core";
import "views/Order/styles/index.scss";

class Resume extends Component {

    render() {
        const { t, plan, planName, order, currency, total, resume, tax } = this.props;
        return (
            <div>
                <div className={`man-header order ${planName}`}>
                    <span>{t("billing:resume.title")}</span>
                </div>
                <div className="man-resume buy">
                    {
                        resume.plan ?
                            <div className="switch">
                                <Divider></Divider>
                                <div>
                                    <div>
                                        <Switch checked={order.period === "annual" ? true : false} disabled />
                                        <p>{t("billing:annual_price")}</p>
                                    </div>
                                    <span>{resume.plan.annual}{t(`billing:currency_${currency}`)}</span>
                                </div>
                                <Divider></Divider>
                                <div>
                                    <div>
                                        <Switch checked={order.period === "monthly" ? true : false} disabled />
                                        <p>{t("billing:monthly_price")}</p>
                                    </div>
                                    <span>{resume.plan.monthly}{t(`billing:currency_${currency}`)}</span>
                                </div>
                                <Divider></Divider>
                            </div> :
                            <p style={{ marginTop: 15 }}>{t("billing:resume.description")}</p>
                    }
                    {
                        resume.services && resume.services.length > 0 &&
                        <div className="man-items">
                            <p>{t("billing:resume.sub_title_01")}</p>
                            <Divider></Divider>
                            {
                                resume.services.map((service, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <div>
                                                <span>{t(`billing:tab_02.${service.name}.title`)}</span>
                                                <span>{service.taxable}{t(`billing:currency_${currency}`)}</span>
                                            </div>
                                            <Divider></Divider>
                                        </React.Fragment>
                                    );
                                })
                            }
                        </div>
                    }
                    {
                        resume.plan && plan !== "plan_s" && resume.integrations.length > 0 &&
                        <div className="man-items">
                            <p>{t("billing:resume.sub_title_02")}</p>
                            <React.Fragment>
                                <Divider></Divider>
                                {resume.integrations.map((integration, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                                <div>
                                                    <span>{integration.name.charAt(0).toUpperCase() + integration.name.slice(1)}</span>
                                                    <span>{integration.taxable}{t(`billing:currency_${currency}`)}</span>
                                                </div>
                                                <Divider></Divider>
                                            </React.Fragment>
                                        );
                                    })
                                }
                            </React.Fragment>
                        </div>
                    }
                    {
                        total &&
                        <div className="man-footer">
                            <Divider></Divider>
                            <div>
                            {
                                tax === 21 ? (
                                    <React.Fragment>
                                        <div>
                                            <span>{t("billing:resume.total")}</span>
                                            <div className="iva">
                                                <span>{total.totalOrder}</span>
                                                <p>{t(`billing:currency_${currency}`)}</p>
                                            </div>
                                        </div>
                                        <div>
                                            <span>IVA</span>
                                            <div className="iva">
                                                <span>{total.totalIva}</span>
                                                <p> {t(`billing:currency_${currency}`)}</p>
                                            </div>
                                        </div>
                                        <div>
                                            <span>{t("billing:resume.totalIVA")}</span>
                                            <div className="iva">
                                                <span>{total.totalPrice}</span>
                                                <p>{t(`billing:currency_${currency}`)}</p>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                        <React.Fragment>
                                            <div>
                                                <span>{t("billing:resume.total")}</span>
                                                <div className={"iva"}>
                                                    <span>{total.totalOrder}</span>
                                                    <p>{t(`billing:currency_${currency}`)}</p>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                            }
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(Resume);
export default withTranslation(["order", "inputs", "billing"])(withRouter(connect_));